import type { DesktopImmersiveState } from "@rakazo/contracts";
import { useEffect, useState } from "react";
import { desktopBridge } from "./desktop";
import { errorText } from "./user-error";

export function useDesktopImmersive() {
  const bridge = desktopBridge()?.immersive;
  const [state, setState] = useState<DesktopImmersiveState>({ enabled: false, active: false });
  const [error, setError] = useState("");
  const [pending, setPending] = useState(false);
  useEffect(() => {
    if (!bridge) return;
    let live = true;
    let changed = false;
    const off = bridge.onChange((value) => {
      changed = true;
      setState(value);
    });
    void bridge
      .state()
      .then((value) => {
        if (live && !changed) setState(value);
      })
      .catch((e) => {
        if (live) setError(errorText(e));
      });
    return () => {
      live = false;
      off();
    };
  }, [bridge]);
  async function set(enabled: boolean) {
    if (!bridge || pending) return;
    setPending(true);
    setError("");
    try {
      setState(await bridge.set(enabled));
    } catch (e) {
      setError(errorText(e));
    } finally {
      setPending(false);
    }
  }
  return { ...state, supported: Boolean(bridge), error, pending, set };
}
